import { _ } from '@icc/shared/helpers';

export type ComplaintV1Status = 'requested' | 'handling' | 'rejected' | 'collected' | 'accepted';

export const ComplaintV1Statuses: Record<ComplaintV1Status, string> = {
    requested: _('COMPLAINT|Zgłoszona'),
    collected: _('COMPLAINT|Odebranie'),
    handling: _('COMPLAINT|Rozpatrywanie'),
    rejected: _('COMPLAINT|Odrzucona'),
    accepted: _('COMPLAINT|Przyjęta'),
};

export const ComplaintV1StatusesColors: Record<ComplaintV1Status, string> = {
    requested: 'ffab45',
    handling: '8764b8',
    rejected: 'e74856',
    collected: '00BCF2',
    accepted: '47d041',
};

export const complaintV1Statuses = Object.keys(ComplaintV1Statuses).map((key) => ({
    value: key,
    label: ComplaintV1Statuses[key],
}));
